import { ROLE_LABELS, type Role } from '@ops/contracts'
import { NavLink } from 'react-router-dom'

import { cx } from '../lib/cx'
import { Icon } from '../ui/Icon'
import { navItemsForRole } from './nav'

/**
 * Navegación por secciones, filtrada por rol. Un rol que no puede ver Revenue
 * tampoco ve el link: ofrecerle una pantalla que le va a devolver 403 es una
 * promesa que el panel no puede cumplir.
 */
export interface SidebarProps {
  rol: Role
  /** Contador por ruta, ej. `{ '/clientes': 4 }`. Marca lo que pide atención. */
  conteos?: Readonly<Record<string, number>>
}

export function Sidebar({ rol, conteos }: SidebarProps) {
  const items = navItemsForRole(rol)

  return (
    <nav
      aria-label="Navegación principal"
      className="sticky top-0 flex h-screen w-sidebar shrink-0 flex-col gap-1 self-start overflow-y-auto border-r border-border bg-surface p-3"
    >
      <div className="mb-4 flex items-center gap-2 px-2">
        <span
          aria-hidden="true"
          className="h-[18px] w-[18px] shrink-0 rounded bg-accent shadow-[inset_0_0_0_1px_rgba(0,0,0,.28)]"
        />
        <span className="min-w-0 truncate text-base font-semibold text-text">
          ops
          <span className="font-normal text-muted">.laburen.com</span>
        </span>
      </div>

      <p className="rotulo px-2 pb-1">Secciones</p>

      {items.map((item) => {
        const conteo = conteos?.[item.to]
        return (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.to === '/'}
            className={({ isActive }) =>
              cx(
                'flex h-[30px] items-center gap-2 rounded-md border-l-2 px-2 text-base font-medium transition-colors duration-150 ease-brand',
                isActive
                  ? 'border-l-accent bg-accent-soft font-semibold text-accent-text'
                  : 'border-l-transparent text-muted hover:bg-n100 hover:text-text',
              )
            }
          >
            <Icon name={item.icon} size={15} />
            <span className="min-w-0 flex-1 truncate">{item.label}</span>
            {conteo !== undefined && conteo > 0 ? (
              <span className="tabular inline-flex h-4 min-w-[18px] items-center justify-center rounded-full border border-danger bg-danger-soft px-1 text-micro font-semibold text-danger-text">
                {conteo}
                <span className="sr-only"> pendientes</span>
              </span>
            ) : null}
          </NavLink>
        )
      })}

      <div className="mt-auto border-t border-border px-2 pt-2 text-micro text-muted-strong">
        <p>Acceso: {ROLE_LABELS[rol]}</p>
        <p className="mt-0.5">El rol se resuelve por email, no se elige acá.</p>
      </div>
    </nav>
  )
}
